import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import AgeImg from '../../assets/img/age.png';

function Promo() {
    return (
        <section className="promo-featured-wrapper section-padding">
            <div className="container">
                <div className="row align-center">
                    <div className="col-xl-6 col-12 text-center">
                        <img src={AgeImg} alt="age" />
                        <h5>
                            Years Of Experience 
                            {/* With <b>Creative Team</b> */}
                        </h5>
                    </div>
                    <div className="col-xl-6 col-12">
                        <div className="block-contents ml-xl-5 mt-5 mt-xl-0">
                            <span>About Company</span>
                            <h1>Vedant Technology</h1>
                            {/* <h4>
                                Capitalise on low hanging fruit to identify a ballpark value added
                                activity to beta test.
                            </h4> */}
                            <p>
                               Vedant Technology is an engineering and manufacturing solutions company providing end-to-end support from new product development to mass production. We specialize in product development, vendor development, manufacturing support, quality audits, and cost optimization across multiple manufacturing processes.

                            </p>
                            <Link to="/contact" className="theme-btn">
                                Know More
                                <BsArrowRight style={{ fontSize: '20px', marginLeft: '15px' }} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Promo;
